// src/pages/yachts/special-offers/components/BrokersPicker.js
import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label } from 'reactstrap';

import { fetchBrokers } from '../../../../brokers/actions';

class BrokersPicker extends React.Component {
    componentDidMount() {
        // The brokers endpoint 500s when search is sent. Preload by page only.
        this.props.fetchBrokers({
            page: 1,
            page_size: 500
        });
    }

    handleChange = (e) => {
        const opts = Array.from(e.target.selectedOptions).map((o) =>
            Number(o.value)
        );
        this.props.input.onChange(opts);
    };

    render() {
        const { input, meta, brokers } = this.props;
        const selected = (input.value || []).map(String);
        return (
            <FormGroup>
                <Label>Allowed brokers</Label>
                <select
                    multiple
                    className="form-control"
                    size={8}
                    value={selected}
                    onChange={this.handleChange}
                >
                    {(brokers || []).map((b) => {
                        const label = (b.name && b.name.trim()) ||
                            b.company ||
                            `Broker #${b.id}`;
                        return (
                            <option key={b.id} value={b.id}>
                                {label}
                                {b.company && b.name ? ` — ${b.company}` : ''}
                            </option>
                        );
                    })}
                </select>
                {meta.touched && meta.error && (
                    <div className="text-danger">{meta.error}</div>
                )}
            </FormGroup>
        );
    }
}

const mapStateToProps = (state) => ({
    brokers: (state.brokers && state.brokers.brokers) || []
});

const mapDispatchToProps = (dispatch) => ({
    fetchBrokers: (params) => dispatch(fetchBrokers(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(BrokersPicker);
